import { render, staticRenderFns } from "./sales-return.vue?vue&type=template&id=b4b924b0&scoped=true&"
import script from "./sales-return.vue?vue&type=script&lang=js&"
export * from "./sales-return.vue?vue&type=script&lang=js&"
import style0 from "./sales-return.vue?vue&type=style&index=0&id=b4b924b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b924b0",
  null
  
)

export default component.exports